<template>
  <div class="bg-neutral-white">
      <CCol sm="12" xs="6" class="text-right">
          <h5 class="custom-18px poppin-font mt-2 text-center" style="padding-top: 40px;">
              <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
              <span style="margin-top:20px">Notification</span>
          </h5>
  
      </CCol>
      <br /><br />
      <div style="clear:both"></div>
      <CCol sm="12" class="text-center" style="width: 90%;background-size: cover; margin: auto;">
      <div>
        <CBadge style="width: 100px" class="custom-badge-primary">Jobs</CBadge>
        <CBadge style="width: 100px" class="custom-badge-default ml-3 mr-3">Awarded</CBadge>
        <CBadge style="width: 100px" class="custom-badge-default">History</CBadge>
      </div>
      </CCol>
      
      <CCol sm="12">
          <br />
          <h1 class="custom-14px">Today</h1>
          <CCard class="border-requested m-2" @click="openJob()">
            
              <CCol sm="12">
              <CRow>
                  <div style="width:20%">
                      <div class="p-2">
                      <img style="width:40px" src="../assets/img/card1.png" />
                  </div>
                  </div>
                  <div style="width:80%">
                      <CRow class="p-2 mt-2">
                          <div style="width:50%">
                              <CButton class="badge-blue">Home Cleaning</CButton>
                          </div>
                          <div style="width:50%"><label class="custom-date-muted">17 Jan 2024 at 10:05 AM</label></div>
                          <h1 class="custom-14px-700 ml-2 mt-2">
                              Atiqah Putri
                          </h1>
                          <div style="width:80%">
                             <h3 class="custom-12px ml-2">A requester offer a cleaning home job for you on saturday (10:00 AM) </h3> 
                          </div>
                          <div style="width:20%"><img src="../assets/img/arrowright.png" /></div>
                      </CRow>
                  </div>
              </CRow>
          </CCol>
          </CCard>

          <CCard class="border-requested m-2" @click="openJob()">
            
            <CCol sm="12">
            <CRow>
                <div style="width:20%">
                    <div class="p-2">
                    <img style="width:40px" src="../assets/img/card2.png" />
                </div>
                </div>
                <div style="width:80%">
                    <CRow class="p-2 mt-2">
                        <div style="width:50%">
                            <CButton class="badge-blue">Home Cleaning</CButton>
                        </div>
                        <div style="width:50%"><label class="custom-date-muted">17 Jan 2024 at 10:05 AM</label></div>
                        <h1 class="custom-14px-700 ml-2 mt-2">
                            Atiqah Putri
                        </h1>
                        <div style="width:80%">
                           <h3 class="custom-12px ml-2">A requester offer a cleaning home job for you on saturday (10:00 AM) </h3> 
                        </div>
                        <div style="width:20%"><img src="../assets/img/arrowright.png" /></div>
                    </CRow>
                </div>
            </CRow>
        </CCol>
        </CCard>

        <CCard class="border-requested m-2" @click="openJob()">
            
            <CCol sm="12">
            <CRow>
                <div style="width:20%">
                    <div class="p-2">
                    <img style="width:40px" src="../assets/img/card3.png" />
                </div>
                </div>
                <div style="width:80%">
                    <CRow class="p-2 mt-2">
                        <div style="width:50%">
                            <CButton class="badge-blue">Home Cleaning</CButton>
                        </div>
                        <div style="width:50%"><label class="custom-date-muted">17 Jan 2024 at 10:05 AM</label></div>
                        <h1 class="custom-14px-700 ml-2 mt-2">
                            Atiqah Putri
                        </h1>
                        <div style="width:80%">
                           <h3 class="custom-12px ml-2">A requester offer a cleaning home job for you on saturday (10:00 AM) </h3> 
                        </div>
                        <div style="width:20%"><img src="../assets/img/arrowright.png" /></div>
                    </CRow>
                </div>
            </CRow>
        </CCol>
        </CCard>

        <div v-if="popupJob == true" class="popup-all backdrop-all" @click="closePopup">
            <div class="popup-all1">
                <!-- Popup content -->
                <label style="color: #000000"><strong>Service Detail</strong></label>
                  <CRow class="ml-1 mr-2" style="color: #000000">
                    <div style="width: 50%" class="float-left">
                      <h6><strong>Name</strong></h6>
                    </div>
                    <div style="width: 50%" class="float-right">
                      : Jhon Dea
                    </div>
                    <div style="clear: both"></div>

                    <br />

                    <div style="width: 50%" class="float-left">
                      <h6><strong>Service Select</strong></h6>
                    </div>
                    <div style="width: 50%" class="float-right">
                      : Home Cleaning
                    </div>
                    <div style="clear: both"></div>

                    <br />

                    <div style="width: 50%" class="float-left">
                      <h6><strong>Date Time</strong></h6>
                    </div>
                    <div style="width: 50%" class="float-right">
                      : Januari 12, 2024
                    </div>
                    <div style="clear: both"></div>

                    <br />

                    <div style="width: 50%" class="float-left">
                      <h6><strong>Phone Number</strong></h6>
                    </div>
                    <div style="width: 50%" class="float-right">
                      : (480) 555-0103
                    </div>
                    <div style="clear: both"></div>

                    <br />
                </CRow>
                <CRow>
                    <CButton type="button" class="button-border-blue text-white mt-4" style="width: 50%" block @click="openApplySuccess()">Apply</CButton>
                    <CButton type="button" class="button-border-red mt-4" style="width: 50%" block>Reject</CButton>
                    <div style="clear: both"></div>
                </CRow>
                
                
            </div>
        </div>

        <div v-if="popupApply == true" class="popup-all backdrop-all" @click="closePopup">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100%" src="../assets/img/success.png" />
                    <h3 class="custom-18px-500 text-center">Applied Successfully</h3>
                    <CButton type="button" class="button-border-blue text-white mt-4" block @click="openWaiting()">OK</CButton>
                </div>
            </div>
        </div>

        <div v-if="popupWaiting == true" class="popup-all backdrop-all" @click="closePopup">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100%" src="../assets/img/sendnoti.png" />
                    <h3 class="custom-18px-500 text-center">Waiting genie helper to approve your wishes</h3>
                    <CButton type="button" class="button-border-blue text-white mt-4" block @click="GoToBooking()">Continue</CButton>
                </div>
            </div>
        </div>
        <br />
      </CCol>
      
  </div>
</template>


<script>
import backgroundUrl from "../assets/img/bgHomeUser.png";
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination,
} from "hooper";

import "hooper/dist/hooper.css";
export default ({
  components: {
      Hooper,
      Slide,
      HooperNavigation,
      HooperPagination,
  },
  data() {
      return {
          isLanguagePopupVisible: false,
          code: ["", "", "", ""],
          hooperSettings1: {
              hideArrows: true,
          },
          backgroundUrl,
          popupJob: false,
          popupApply: false,
          popupWaiting: false,

      }

  },
  methods: {
      GoToPrevious() {
          this.$router.go(-1);
      },
      openJob()
      {
          this.popupJob = true;
      },
      openApplySuccess()
      {
          this.popupApply = true;
          this.popupJob = false;
      },
      openWaiting()
      {
          this.popupWaiting = true;
          this.popupApply = false;
      }

     

  }
})
</script>

<style scoped>
body {
  top: 0 !important;
  font-family: 'Poppins', sans-serif;
}
</style>